import React from 'react';
import { TextField } from '@material-ui/core';
import { useField } from 'formik';
import moment from 'moment';

const DateTimeWrapper = ({ name, ...otherProps }) => {
  const [field, meta] = useField(name);

  const configDateTime = {
    ...field,
    ...otherProps,
    type: 'date',
    fullWidth: true,
    size: 'small',
    variant: 'outlined',
    InputLabelProps: {
      shrink: true
    }
  };

  if (meta && meta.touched && meta.error) {
    configDateTime.error = true;
    configDateTime.helperText = meta.error;
  }

  return <TextField {...configDateTime} />;
};

export default DateTimeWrapper;
